package org.tlsys.admin.ui


class SearchInput(value: String = "", placeHolder: String = "") : InputTextString(value = value, placeHolder = placeHolder, password = false) {
    init {
        dom.classList.add("searchInput")
    }
}
